export default "__VITE_ASSET__D62ee7WR__"